<template lang="pug">
  b-modal#updateSubAccount(
    ref="updateSubAccount"
    :title="$t('ui.combine.edit_profile')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.account_id") }}
        DebounceInput(
          type="text"
          ref="account_id"
          :placeholder='$t("ui.account_id")'
          :value="accountId.toUpperCase()"
          readonly
        )
      .form-group
        label {{ $t("ui.full_name") }}
        DebounceInput(
          type="text"
          ref="full_name"
          :dirty="$v.full_name.$dirty"
          :error="$v.full_name.$error"
          :placeholder='$t("ui.full_name")'
          v-model.trim.lazy="$v.full_name.$model"
          :maxLength="$v.full_name.$params.maxLength.max"
          :disabled="loading"
        )
        ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
      .form-group
        label {{ $t("ui.contact_phone") }}
        DebounceInput(
          type="text"
          ref="contact_phone"
          :dirty="$v.contact_phone.$dirty"
          :error="$v.contact_phone.$error"
          :placeholder='$t("ui.contact_phone")'
          v-model.trim.lazy="$v.contact_phone.$model"
          :maxLength="$v.contact_phone.$params.maxLength.max"
          :disabled="loading"
        )
        ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
      //- .form-group(v-if="!$helpers.isAgentLevel()")
      //-   label {{ $t("ui.contact_email") }}
      //-   DebounceInput(
      //-     form=true
      //-     type="text"
      //-     ref="contact_email"
      //-     :dirty="$v.contact_email.$dirty"
      //-     :error="$v.contact_email.$error"
      //-     :placeholder='$t("ui.contact_email")'
      //-     v-model.trim.lazy="$v.contact_email.$model"
      //-     :disabled="loading"
      //-   )
      //-   ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel" :disabled="$helpers.isSuspended()")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, maxValue, minLength, maxLength, email, numeric } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      full_name: "",
      contact_phone: "",
      contact_email: "",
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    full_name: {
      // minLength: minLength(6),
      maxLength: maxLength(30)
    },
    contact_phone: {
      numeric,
      minLength: minLength(9),
      maxLength: maxLength(20)
    },
    // contact_email: {
    //   email,
    //   maxLength: maxLength(100)
    // }
  },
  computed: {},
  mounted: function() {},
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    getSubAccountDetails: function() {
      let sub_login_id = this.accountId
      this.loading = true
      if(sub_login_id) {
        this.$store
        .dispatch("user/getSubAccountDetails", { sub_login_id })
        .then(response => {
          this.loading = false
          this.full_name = response.data.details[0].full_name
          this.contact_phone = response.data.details[0].contact_phone
          // this.contact_email = response.data.details[0].contact_email
        })
        .catch(response => {
          console.log("Failed:getSubAccountDetails", response)
          this.loading = false
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_sub_account_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateSubAccount()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_sub_account_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateSubAccount: function() {
      let account_id = this.accountId
      let full_name = this.full_name
      let contact_phone = this.contact_phone
      let contact_email = this.contact_email
      this.$store
        .dispatch("user/updateSubAccount", { account_id, full_name, contact_phone, contact_email })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_sub_account_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:updateSubAccount", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.full_name = ""
      this.contact_phone = ""
      this.contact_email = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset();
        this.getSubAccountDetails()
      });
    },
    cancel: function() {
      this.$emit("clicked")
      this.$refs.updateSubAccount.hide()
    }
  }
}
</script>